// extracted by mini-css-extract-plugin
export var fadeInOut = "_3h-3";
export var icon = "_3h-4";
export var savedIndicator = "_3h-2";
export var savingIndicator = "_3h-0";
export var spin = "_3h-1";